import {
  Heading,
  Stack,
} from '@chakra-ui/react';

import UserCard from '../components/userCard/UserCard';

const people = [
  {
    name: 'Aroha Kaa',
    company: 'Director of Technology @ Entain',
    emoji: '💜',
    emojiColour: '#9399BF',
    image: 'https://media-exp1.licdn.com/dms/image/C4D03AQFJ70hhGd8Dgg/profile-displayphoto-shrink_200_200/0/1654565474619?e=1663804800&v=beta&t=dOjXnJkL-wfsQFZSqq0Bn6qCsQxidFkIvQP1ABl4aMg',
    video: 'https://res.cloudinary.com/entainhacker/video/upload/v1658570238/Hackathon-Entain/6_u7keib.mp4',
    linkedin: 'https://www.linkedin.com/in/arohaekaa/',
  },
  {
    name: 'Carly Shearman',
    company: 'Principal Consultant @ Hunt & Co',
    emoji: '🥞',
    emojiColour: '#AF9C7A',
    image: 'https://media-exp1.licdn.com/dms/image/C5603AQFud-L7rGR_WQ/profile-displayphoto-shrink_200_200/0/1620187035198?e=1663804800&v=beta&t=MrCvDA02x47IAIDq7QfenGWweDyaLI-rVkotw5UV-Vo',
    video: 'https://res.cloudinary.com/entainhacker/video/upload/v1658561137/Hackathon-Entain/2_ur7abj.mp4',
    linkedin: 'https://www.linkedin.com/in/carly-shearman/',
  },
  {
    name: 'Claire Holmes',
    company: 'Corporate Communications Manager @ Entain',
    emoji: '🤪',
    emojiColour: '#9153AF',
    image: 'https://media-exp1.licdn.com/dms/image/C5603AQFfXPtiw-L5vA/profile-displayphoto-shrink_800_800/0/1634169360935?e=1663804800&v=beta&t=XwvVpKZsjQL_1kuWpqFa8oUhsVBYtQ_Pjt5YR6Dc5_c',
    video: 'https://res.cloudinary.com/entainhacker/video/upload/v1658560718/Hackathon-Entain/1_vyc46g.mp4',
    linkedin: 'https://www.linkedin.com/in/claire-banfield/',
  },
  {
    name: 'Caitlin Watson-Beaton',
    company: 'Software Engineer @ IntelliHR',
    emoji: '😝',
    emojiColour: '#58CF53',
    image: 'https://media-exp1.licdn.com/dms/image/C5603AQF7YZ03vfSi3A/profile-displayphoto-shrink_200_200/0/1624866533421?e=1663804800&v=beta&t=lmQwEXPNvHmrZOnlDvG2UyXYr9vdSnhbEEclVW90udQ',
    video: 'https://res.cloudinary.com/entainhacker/video/upload/v1658561307/Hackathon-Entain/5_ydostu.mp4',
    linkedin: 'https://www.linkedin.com/in/watsonbeaton/',
  },
  {
    name: 'Colleen Gao',
    company: 'Head of Growth @ Askable',
    emoji: '😊',
    emojiColour: '#F85066',
    image: 'https://media-exp1.licdn.com/dms/image/C5603AQGVOZiSIfmW8w/profile-displayphoto-shrink_200_200/0/1591159916350?e=1663804800&v=beta&t=ul2qq9MDgkp8TAMlwTBx7KE-NVVIgkyedfoi02zpfv0',
    video: 'https://res.cloudinary.com/entainhacker/video/upload/v1658571314/Hackathon-Entain/3_l1bpzx.mp4',
    linkedin: 'https://www.linkedin.com/in/justgaoforit/',
  },
]

const  shuffle = (array) => {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

// Random Shuffle Logic

let shuffledArray = [];

let lastShuffle = shuffledArray;

shuffledArray = shuffle(people);

if (lastShuffle[0] === shuffledArray[0]) {
  shuffledArray = shuffledArray.reverse();
}




function Experiences() {
  return (
    <div className="experiences-page page">
      <Heading
        mt={10} mb={4}
        color={'brand.main'}
        className='text-focus-in'
      >
        Experiences
      </Heading>
      <Stack
          className="cards fade-in-bottom-1"
          direction={{ base: 'column', md: 'row' }}
          spacing={{ base: 10, md: 4, lg: 10 }}
        >
        {shuffledArray.map((person) => (
          <UserCard
            key={person.name}
            name={person.name}
            company={person.company}
            info={person.info}
            emoji={person.emoji}
            emojiColour={person.emojiColour}
            image={person.image}
            video={person.video}
            linkedin={person.linkedin}
            twitter={person.twitter}
            github={person.github}
            link={person.link}
          />
        ))}
      </Stack>
    </div>
  );
}

export default Experiences;
